import { License } from '@models';

export interface RepositoriesLicensesResult {
  vulnerabilityLicensesDetails: License[];
}
